import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _12mpIcon(props: IconProps) {
    return <Icon {...props} iconKey={"12mp"}/>
}
